import { FileDao } from './file.dao';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class FileService {
	constructor(private fileDao: FileDao) {}

	/**
	 * @description
	 * Gets a data file by name and type
	 */
	public getDataFileByType$(fileName: string, fileType: string, retries?: number): Observable<any> {
		return this.fileDao.getDataFileByType$(fileName, fileType, retries);
	}
}
